import SchedulingHistoryContent from './components/SchedulingHistoryContent';

/**
 * Standalone Scheduling History page (`/scheduling/history`). The filter bar and
 * results table are shared with the drawer on the LC/Scheduler boards — see
 * components/SchedulingHistoryContent.tsx.
 */
export default function SchedulerHistory() {
  return <SchedulingHistoryContent />;
}
